<template>
  <div class="text-left row">

    <div v-bind:class="[ menuMensagens ?  menuMensagens : 'col-md-8 offset-md-2', 'col-md-6']">

      <div class="row" v-show="errLog.msg || msgLog.msg || successLog.msg">
        <div class="col">
          <div class="subtitle text-center col-12  mb-2 ">Logs de envio</div>

          <div class="col-12 alert alert-realy-danger" v-show="errLog.msg">
            <p>{{ errLog.time }}</p>
            <p>{{ errLog.msg }}</p>
            <button class="btn btn-success col" style="background-color: #99d1a6" @click="reloadPage()" >
              Novo envio
            </button>
          </div>
          <div class="col-12 alert alert-realy-success" v-show="successLog.msg" >
            <p>{{ successLog.time }}</p>
            <p>{{ successLog.msg }}</p>
            <button class="btn btn-success col" style="background-color: #1f9139" @click="reloadPage()" >
              Novo envio
            </button>
          </div>
          <div class="col-12 alert alert-info" v-show="msgLog.msg">
            <p>{{ msgLog.time }}</p>
            <p>{{ msgLog.msg }}</p>
          </div>
        </div>
        <divider/>
      </div>

      <div class="row mt-4 " :class="{disabled: processing}">
        <div class="col-12">
          <div id="inicio" class="subtitle text-center col-12 mb-2 ">Montagem do envio</div>
          <label id="carregaArquivo"  for="file-upload" class="col-12 mt-2 btn btn-md btn-success" title="Escolha um arquivo com até 1000 registros para enviar">
              Carregar arquivo de mensagens
              <font-awesome-icon icon="file" class="pointer" />
          </label>
          <input id="file-upload" type="file" style="display: none" ref="myFile" @change="previewFile"/>

          <div  class=" col-12 alert alert-info">
            As linhas do arquivo deve seguir o formato: <strong>numero;mensagem</strong>
            <a download :href="`${host}/files/uploadArquivoExemploBestuse.zip`" class="ml-2 p-1 btn-info">Baixar exemplos</a> <br>
            <b><i>Ex: <strong> 11999998888;Bom dia </strong></i></b>
          </div>
        </div>
        <divider/>
      </div>

      <div class="col-12 text-center " :class="{disabled: processing}">
        <div class="row" id="agendamento">
          <div class="subtitle col-12 mt-3 mb-2 ">Agendamento do envio</div>
          <div class="form-check form-check col-6">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="imediato" value="true" v-model="form.envioImediato">
            <label class="form-check-label" for="imediato">Envio imediato</label>
            <small id="emailHelp" class="form-text text-muted">Envio daqui a 5 minutos</small>
          </div>
          <div class="form-check form-check col-6">
            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="agendado" value="false" v-model="form.envioImediato">
            <label class="form-check-label" for="agendado">Agendado</label>
            <small id="emailHelp" class="form-text text-muted">Envio conforme o agendamento</small>
          </div>
        </div>

        <div v-if="form.envioImediato == 'false'" class="col-sm-12">
          <div class="row">

            <p class=" col-sm-12 text-center">Programar agendamento</p>
            <div class="form-check form-check col-sm-6 mt-2">
              <datepicker calendar-class="form-control" v-model="form.data" input-class="form-control" placeholder="Data" :language="ptBR" style="color: #000">
              </datepicker>
            </div>
            <div class="form-check form-check col-sm-6 mt-2">
                <the-mask :mask="['##:##']" v-model="form.horario" class="form-control " placeholder="Horário"/>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <button
            type="submit"
            :disabled="processing"
            @click="send"
            class="botaoEnviar  btn btn-success col-md-8 col-xl-4 mt-3 mb-3 mx-auto"
            v-if="form.mensagens.length > 0">
            Enviar
          </button>
          <div v-if="form.mensagens.length == 0" class="botaoEnviar alert alert-warning col-sm-12 col-md-4 mt-4 mx-auto text-center" >
            Adicione mensagens para enviar
          </div>
        </div>
      </div>

      <div class="col-12 mt-2">
        <my-alert
          class="alert-success col-12 text-center"
          @done='showSuccess = false'
          :message ='successMessage'
          :show='showSuccess'
        ></my-alert>
        <my-alert
          class="alert-danger col-12 text-center"
          @done='showError = false'
          :message ='errorMessage'
          :show='showError'
          :timeout="10000"
        ></my-alert>
      </div>
    </div>

    <div class="col-md-6" v-if="menuMensagens">
      <div class="row form-group">
        <div class="col-sm-12" id="mensagensAdicinaddas">
          <label for="numero">
            <span id="linhasArquivo" class="ml-2">
              {{ form.totalLinhasArquivo }} linhas no arquivo
              <small>(mostrando as {{ form.mensagens.length > 20 ? 20 : form.mensagens.length }} primeiras)</small>:
            </span>
          </label>
          <div class="alert alert-warning" v-if="form.mensagens.length == 0">
            <b>Atenção!</b> Nenhuma mensagem adicionada
          </div>
        </div>

        <div class="col-sm-12"  id="listmensagens">
          <div class="smsToSend" v-for="(sms, $index) in getLast" :key="$index">
            <span class="messageNumber">{{sms.numero | phone}}</span> - {{sms.mensagem}}
          </div>
        </div>
      </div>
    </div>

    <font-awesome-icon @click="startTutorial()" id="help-button" alt="precisando de ajuda" icon="question-circle" class="pointer"/>

    <v-tour name="myTour" :steps="tutorial.steps" :options="tutorial.myOptions"></v-tour>
  </div>
</template>

<script>

import jwtDecode from 'jwt-decode';
import Datepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import axios from 'axios';
import EventBus from './../../core/eventBus';
import SelecionaAgenda from './../agendaContato/SelecionaAgenda';
import SelecionaMensagem from './../mensagens/SelecionaMensagem';

export default {
  data() {
    return {
      menuMensagens: false,
      decoded: this.$store.getters.decoded,
      ptBR: ptBR,
      host: `${location.protocol}//${location.host}/`,
      form: {
        data: new Date(),
        horario: moment().add(5 ,'minutes').format('HHmm'),
        mensagens:[],
        decoded: '',
        agendamento:{},
        envioImediato: 'true',
        totalLinhasArquivo:0,
      },
      errLog: {
        msg: '',
        time:false,
      },
      msgLog: {
        msg: '',
        time:false,
      },
      successLog: {
        msg: '',
        time:false,
      },
      fileSelected: {},
      processing: false,
      selectedMensagem: 0,
      tutorial:{
          myOptions: {
          labels: {
            buttonSkip: "Pular tutorial",
            buttonPrevious: "Anterior",
            buttonNext: "Próximo",
            buttonStop: "OK!"
          }
        },
        steps: [
          {
            target: "#inicio",
            content:
              "Olá! Vamos ajudá-lo no seu primeiro envio!"
          },
          {
            target: "#carregaArquivo",
            content:
              "Aqui você pode selecionar um arquivo de mensagens! Lembre-se, ele deve ser um .CSV no formato 'numero;mensagem'"
          },
          {
            target: "#agendamento",
            content:
              "Você pode enviar de duas formas.Com o envio imediato (início daqui a 5 minutos) ou então agendar o envio para um horário específico."
          },
          {
            target: "#mensagensAdicinaddas",
            content: "Aqui ficam listadas as 20 primeiras mensagens do arquivo. Todas as mensagens do arquivo são processadas pelo servidor após a confirmação do envio"
          },
          {
            target: "#linhasArquivo",
            content: "Aqui é informado o total de mensagens no arquivo"
          },
          {
            target: ".botaoEnviar",
            content: "Após adicionadas as mensagens, clique no botão ENVIAR que aparece aqui"
          },
          {
            target: ".botaoEnviar",
            content: "Após o envio do arquivo, o sistemá irá quebrá-lo em lotes de 10 mil mensagens (caso o total de mensagesns seja maior que 10 mil)."
          },
          {
            target: ".botaoEnviar",
            content: "Aguarde a mensagem de confirmação de sucesso chegar para então iniciar um novo envio."
          },
        ],
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.processing) {
      this.$modal.show('dialog', {
        dialog: true,
        title: 'Atenção!',
        text: 'Você não pode sair dessa tela até o envio ser finalizado',
        buttons: [
          {
            title: 'Fechar',
          },
        ]
      });
      next(false);
    } else {
      next();
    }
  },
  async mounted() {
    const jaTour = localStorage.getItem("tour");

    if (!jaTour) {
      this.$tours["myTour"].start();
      localStorage.setItem("tour", true);
    }

    EventBus.$on('setMensagem', async (data) => {
      this.form.inputMensagem = data.mensagem;
    });
  },
  computed: {
    getLast(){
      return this.form.mensagens.slice(0,20);
    }
  },
  sockets: {
    uploadV3Status: async function (data) {

      if (data.decoded._id == this.decoded._id) {
        if(data.type == 'err') {
          this.errLog.msg = data.msg;
          this.errLog.time = data.time;
          this.processing = true;
        } else if(data.type == 'final') {
          this.msgLog.msg = '';
          this.msgLog.time = '';
          this.successLog.msg = data.msg;
          this.successLog.time = data.time;
          this.processing = true;
        } else if(data.type == 'msg') {
          this.msgLog.msg = data.msg;
          this.msgLog.time = data.time;
          this.processing = true;
        }

        if(data.type == 'err' || data.type == 'final') {
           // atualizar total saldo
          let cc = await this.$http.get(`/v1/recargas/getSaldo/${this.decoded._id}`);
          this.$store.commit('setSaldo', cc.saldo ? cc.saldo : 0 );
        }
      }
    }
  },
  methods: {
    reloadPage(){
      this.form = {
        data: new Date(),
        horario: moment().add(5 ,'minutes').format('HHmm'),
        mensagens:[],
        decoded: '',
        agendamento:{},
        envioImediato: 'true',
        totalLinhasArquivo:0,
      };
      this.errLog = {
        msg: '',
        time:false,
      };
      this.msgLog = {
        msg: '',
        time:false,
      };
      this.successLog = {
        msg: '',
        time:false,
      };
      this.fileSelected = {};
      this.processing = false;
    },
    startTutorial(){
      this.menuMensagens = true;
      this.$tours["myTour"].start();
    },
    checkTime() {
      if (this.form.envioImediato == 'false') {
        if (this.form.horario.length == 4) {
          let hora = this.form.horario.slice(0,2);
          let minuto = this.form.horario.slice(2,4);
          let aviso = false;

          if (minuto >= 60) {
            aviso = true;
            minuto = 59;
          }

          if (hora < 8) {
            aviso = true;
            hora = '08';
          }

          if (hora > 21 || (hora == 21 && minuto > 0)) {
            aviso = true;
            hora = 21;
            minuto = '00';
          }

          if (aviso) {
            this.$toasted.show('Limite de horario: das 8:00 às 21:00', { icon: 'info', type: 'info' });
            this.form.horario = `${hora}${minuto}`;
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    previewFile(e) {
      this.menuMensagens = true
      this.form.mensagens = [];
      const file = e.target.files[0];
      this.fileSelected = file;
      this.processing = true;

      let formData = new FormData();
      formData.append('file', this.fileSelected);

      this.msgLog.time = moment().format('DD/MM/YYYY HH:mm:ss');
      this.msgLog.msg = 'Aguarde, processando preview do arquivo';

      this.errLog.msg = '';

      const app = this;
      axios.post(`${process.env.VUE_APP_API}/api/v1/v3/uploadArquivo/preview`,
        formData,
        {
          headers: {
            'Authorization': this.$store.getters.authToken,
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function(res){
        console.log(res);

        if (res.data.success) {

          for (let i = 0; i < res.data.preview.length; i++) {
            const msg = res.data.preview[i];
            app.form.mensagens.push({
              numero: msg[0],
              mensagem: msg[1],
            });
          }

          app.form.totalLinhasArquivo = res.data.total;
          app.processing = false;

          app.msgLog = {
            msg: 'Arquivo processado, verifique as primeiras linhas do arquivo ao lado',
            time: moment().format('DD/MM/YYYY HH:mm:ss'),
          };

        } else {
          app.errLog.time = moment().format('DD/MM/YYYY HH:mm:ss');
          app.errLog.msg = res.data.err;
          app.fileSelected = false;
          app.processing = false;
          app.msgLog.msg = '';
        }
      })
      .catch(function(err){

        app.errLog.time = moment().format('DD/MM/YYYY HH:mm:ss');
        app.errLog.msg = err;
        app.fileSelected = false;
        app.processing = false;
        app.msgLog.msg = '';
      });
    },

    async send() {
      let check = this.checkTime();
      if (!check) {
        return
      }

      let hora = this.form.horario.slice(0,2);
      let minuto = this.form.horario.slice(2,4);
      let sendData = moment(this.form.data).hour(hora).minute(minuto).second('00');

      if (
        this.form.mensagens.length > 0 &&
        this.fileSelected&&
        (
          this.form.envioImediato == 'true' ||
          (
            this.form.envioImediato == 'false' &&
            moment(new Date()).isBefore(sendData)
          )
         )
      ) {

        this.processing = true;

        let formData = new FormData();
        formData.append('file', this.fileSelected);

        if (this.form.envioImediato == 'true') {
          formData.append('envioImediato', true);
        } else {
          formData.append('envioImediato', false)
          formData.append('agendamento', JSON.stringify([{
            quantidade: '100',
            dataHoraInicio: sendData.format('YYYY-MM-DD HH:mm:ss'),
            dataHoraFim: sendData.add(4, 'seconds').format('YYYY-MM-DD HH:mm:ss')
          }]));
        }

        const app = this;

        axios.post(`${process.env.VUE_APP_API}/api/v1/v3/uploadArquivo`,
          formData,
          {
            headers: {
              'Authorization': this.$store.getters.authToken,
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function(res){
          if (res.data.success) {
            app.msgLog.time = moment().format('DD/MM/YYYY HH:mm:ss'),
            app.msgLog.msg = res.data.msg;
          } else {
            app.errLog.time = moment().format('DD/MM/YYYY HH:mm:ss');
            app.errLog.msg = res.data.err;
          }
        })
        .catch(function(err){
          this.errLog.time = moment().format('DD/MM/YYYY HH:mm:ss');
          this.errLog.msg = err;
        });
        this.menuMensagens = false
      } else {
        this.showError = true;
        this.errorMessage = 'Informe pelo menos uma mensagem com número. O agendamento deve ser feito das 8:00 as 21:00 e depois do horario atual';
      }

    }
  },
  components: {
    Datepicker,
  }
};
</script>

<style>
  .form-check-input {
    margin-left: -15px;
  }

  #listmensagens {
    max-height: 650px;
    overflow-y: scroll;
  }

  .smsToSend {
    padding: 10px 0px
  }

  .messageNumber {
    font-weight: bold;
    font-size: 15px;
    padding: 0px 0px 0px 10px ;
  }

  strong {
    font-weight: bold
  }

  #help-button {
    background-color: rgb(88, 99, 128, 0.5) !important;
    height: 50px;
    width: 50px;
    position: fixed;
    top: 105px;
    right: 3%;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 50px;
    text-decoration: none;
    z-index: 999;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transition: 0.5s ease-out;
    transition: 0.2s ease-out;
    display: inline-block;
    border-radius: 50%;
  }

  #help-button:hover {
    background-color: #7e007b;
    -webkit-transform: scale(1);
  }

  .vue-dialog {
    color: #171a22
  }
</style>
